var React = require( 'react' );
var PropTypes = require('prop-types');
var createReactClass = require('create-react-class');

var QuestionTitle = createReactClass({
  render: function(){
    return (
		<div>
        	<div className="row">
        		<div id="question" className="large-8 medium-10 small-12 small-centered column text-center">
        			<h2>{this.props.mainLabel} <strong>{this.props.subLabel}</strong></h2>
        		</div>
                <hr className="small-10 small-centered column" />
        	</div>
		</div>
    )
  }
});

QuestionTitle.propTypes = {
  mainLabel: PropTypes.string.isRequired,
  subLabel: PropTypes.string.isRequired
};

module.exports = QuestionTitle;



// WEBPACK FOOTER //
// ./src/common/routes/components/questionTitle.jsx